
import { defineComponent, computed, ref, watch } from 'vue'
import { useStore } from '@/store'
import { usePermission } from '@/hooks/use-permission'
import SbTable from '@/base-ui/table'

export default defineComponent({
  props: {
    contentTableConfig: {
      type: Object,
      required: true
    },
    pageName: {
      type: String,
      required: true
    },
    pageUrl: {
      type: String,
      required: true
    },
    otherParams: {
      type: Object
    },
    methods: {
      type: String,
      default: 'post'
    }
  },
  components: {
    SbTable
  },
  emits: ['newBtnClick', 'editBtnClick'],
  setup(props, { emit }) {
    const store = useStore()
    // 0.获取操作的权限
    const isCreate = usePermission(props.pageName, 'create')
    const isDelete = usePermission(props.pageName, 'delete')
    // const isQuery = usePermission(props.pageName, 'query')
    const isUpdate = usePermission(props.pageName, 'update')

    // 1.双向绑定pageInfobeit
    const pageInfo = ref({ currentPage: 1, pageSize: 10 })
    const queryValue = ref({})

    watch(pageInfo, () => {
      getPageData(queryValue.value);
    })
 
    // 2.发送网络请求
    const getPageData = (queryInfo: any = {}) => {
      // if (!isQuery) return //如果没有查询权限不请求
      queryValue.value = queryInfo
      store.dispatch('system/getPageListAction', {
        pageName: props.pageName,
        pageUrl: `${props.pageUrl}?pageSize=${pageInfo.value.pageSize}&pageNum=${pageInfo.value.currentPage}`,
        queryInfo: {
          ...queryInfo,
          ...props.otherParams
        },
        methods: props.methods
      })
    }
    getPageData()

    // 3.从vuex中获取数据
    const dataList = computed(() =>
      store.getters[`system/pageListData`](props.pageName)
    )
    const dataCount = computed(() =>
      store.getters[`system/pageListCount`](props.pageName)
    )
    // 4.获取其他的动态插槽名称
    const otherPropSlots = props.contentTableConfig?.propList.filter(
      (item: any) => {
        if (item.slotName === 'status') return false
        if (item.slotName === 'createAt') return false
        if (item.slotName === 'updateAt') return false
        if (item.slotName === 'handler') return false
        return true
      }
    )

    // 5.删除/编辑/新建操作
    const handleDeleteClick = (item: any) => {
      console.log(item)

      store.dispatch('system/deletePageDataAction', {
        pageName: props.pageName,
        id: item.id
      })
    }

    const handleNewClick = () => {
      emit('newBtnClick')
    }
    const handleEditClick = (item: any) => {
      emit('editBtnClick', item)
    }
    return {
      dataList,
      getPageData,
      dataCount,
      pageInfo,
      otherPropSlots,
      isCreate,
      isDelete,
      isUpdate,
      handleDeleteClick,
      handleNewClick,
      handleEditClick
    }
  }
})
